import { ApiUrl } from "../utils/modules";
class ContatServices {
  constructor(api) {
    this.api = api;
  }

  contactAdmin(data) {
    return this.api.post(ApiUrl + "contact", data);
  }  
}

export default ContatServices;
